import { Serializable, JsonProperty } from "typescript-json-serializer";
import {Flow} from"../../../../base/model/domain/Flow";
@Serializable()
export class State {
    @JsonProperty()
    _id: string;

    @JsonProperty()
    name: string;
    
    @JsonProperty()
    flow?: Flow;

    @JsonProperty()
    key: string;
}